import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, Response, UserExist } from '@viso/core/models';
import { ENVIRONMENT } from '../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class PhoneNumberService {
  constructor(
    @Inject(ENVIRONMENT) private environment: Environment,
    private http: HttpClient
  ) {}

  userExist(country_code, phone, userType) {
    return this.http.post<Response<UserExist>>(`${this.environment.API_URL}/user-exists`, {
      country_code,
      phone,
      user_type: userType,
    });
  }
}
